'use client'

import { Tooltip } from '@qr-front/ui/components/Tooltip'
import { cn, isTouchDevice } from '@qr-front/ui/utils'
import { ComponentProps, useRef } from 'react'

import { TSvgIcon } from '@/types'

export const SocialPlatformButton = ({
	name,
	Icon,
	isSelected,
	className,
	...props
}: ComponentProps<'button'> & {
	name: string
	Icon: TSvgIcon
	isSelected: boolean
}) => {
	const buttonRef = useRef<HTMLButtonElement>(null)

	return (
		<>
			<Tooltip
				anchorRef={buttonRef}
				delay={300}
				hideOnScroll
				forceVisible={isTouchDevice ? isSelected : undefined}
			>
				{name}
			</Tooltip>
			<button
				ref={buttonRef}
				className={cn(
					'relative flex size-12 shrink-0 items-center justify-center rounded-8 ring-1 ring-inset ring-border-grey transition-colors',
					isSelected && 'ring-2 ring-blue',
					className,
				)}
				{...props}
			>
				<Icon />
			</button>
		</>
	)
}
